"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
//
// assets
//
const noApiKeys_webp_1 = __importDefault(require("assets/images/dashboard/noApiKeys.webp"));
const appsCopy_1 = require("copy/appsCopy");
const Toast_1 = __importDefault(require("components/general/Toast/Toast"));
const useToast_1 = __importDefault(require("components/general/Toast/useToast"));
//
// components
//
const AppModule_1 = __importDefault(require("./AppModule"));
//
// styles
//
const StyledHeader_1 = require("components/Dashboard/StyledHeader");
const StyledMainContainer_1 = require("components/Dashboard/StyledMainContainer");
const StyledMessageContainer_1 = require("components/Dashboard/StyledMessageContainer");
const LoadingSpinner_1 = __importDefault(require("components/general/LoadingSpinner"));
const StyledErrorText_1 = require("components/Dashboard/StyledErrorText");
const StyledGraphic_1 = require("components/Dashboard/StyledGraphic");
const StyledMediumText_1 = require("components/Dashboard/StyledMediumText");
const StyledGreyText_1 = require("components/Dashboard/StyledGreyText");
const graphql_1 = require("./graphql");
const AccountContext_1 = require("contexts/AccountContext");
const Apps = () => {
    const { account } = (0, AccountContext_1.useAccount)();
    const { id: accountId } = account || {};
    const [getAppListings, { data, error }] = (0, client_1.useLazyQuery)(graphql_1.GET_APP_LISTINGS);
    const [uninstallAppMutation, { data: uninstallData }] = (0, client_1.useMutation)(graphql_1.UNINSTALL_APP);
    const { toastParams, setToastMessage } = (0, useToast_1.default)();
    const uninstallApp = (clientId) => {
        if (!accountId) {
            return;
        }
        // we have to read `clientId` from the getAppListings call
        // but send it back as `appClientId`
        uninstallAppMutation({
            variables: {
                input: {
                    accountId: accountId,
                    appClientId: clientId
                }
            }
        });
    };
    (0, react_1.useEffect)(() => {
        if (accountId) {
            getAppListings({ variables: { accountId } });
        }
    }, [accountId]);
    (0, react_1.useEffect)(() => {
        if (uninstallData && accountId) {
            setToastMessage('Uninstalled');
            getAppListings({ variables: { accountId } });
        }
    }, [uninstallData]);
    function listApps() {
        const appArray = data === null || data === void 0 ? void 0 : data.appListings.map((app) => {
            return (react_1.default.createElement(AppModule_1.default, { app: app, key: app.clientId, onUninstall: uninstallApp }));
        });
        appArray === null || appArray === void 0 ? void 0 : appArray.push(react_1.default.createElement(AppModule_1.default, { app: {
                id: 'rebuy',
                category: '',
                clientId: '',
                installUrl: 'https://help.gomalomo.com/csc/how-to-set-up-a-rebuy-widget-for-your-malomo-track',
                installed: false,
                name: 'Rebuy',
                insertedAt: '',
                updatedAt: ''
            }, key: 'rebuy', 
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onUninstall: () => { } }));
        appArray === null || appArray === void 0 ? void 0 : appArray.push(react_1.default.createElement(AppModule_1.default, { app: {
                id: 'gorgias',
                category: '',
                clientId: '',
                installUrl: 'https://help.gomalomo.com/csc/integrating-malomo-gorgias',
                installed: false,
                name: 'Gorgias',
                insertedAt: '',
                updatedAt: ''
            }, key: 'gorgias', 
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onUninstall: () => { } }));
        return react_1.default.createElement("div", null, appArray);
    }
    function renderLoading() {
        return (react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
            react_1.default.createElement(LoadingSpinner_1.default, null),
            react_1.default.createElement(StyledMediumText_1.StyledMediumText, { className: 'loading', role: 'paragraph' }, appsCopy_1.appsCopy.loading)));
    }
    function displayError() {
        if (!error) {
            return null;
        }
        if (error.message.includes('ECONNREFUSED') ||
            error.message.toLowerCase().includes('failed')) {
            return (react_1.default.createElement(StyledErrorText_1.StyledErrorText, { className: 'error', role: 'alert' }, appsCopy_1.appsCopy.fetchError));
        }
        return (react_1.default.createElement(StyledErrorText_1.StyledErrorText, { className: 'error', role: 'alert' }, error.message));
    }
    // should never happen during normal use
    function renderNoRecords() {
        return (react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
            react_1.default.createElement(StyledGraphic_1.StyledGraphic, { alt: 'robotic arm holding a key up to a computer screen', src: noApiKeys_webp_1.default }),
            react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'header no-records', role: 'heading' }, appsCopy_1.appsCopy.noAppsHeader),
            react_1.default.createElement(StyledGreyText_1.StyledGreyText, { className: 'no-records-paragraph', role: 'paragraph' }, appsCopy_1.appsCopy.noAppsParagraph)));
    }
    function renderApps() {
        return (react_1.default.createElement(StyledMainContainer_1.StyledMainContainer, { className: 'apps' },
            react_1.default.createElement(Toast_1.default, Object.assign({}, toastParams)),
            react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'header', role: 'heading' }, appsCopy_1.appsCopy.mainHeader),
            listApps()));
    }
    if (error) {
        return displayError();
    }
    if (data && data.appListings.length === 0) {
        return renderNoRecords();
    }
    if (data) {
        return renderApps();
    }
    return renderLoading();
};
exports.default = Apps;
